import React from 'react' 
const HomeSlider = () => {
  return (
    <>
    <div className="slider-sec">
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"> 
    <div className="row"> 
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel"> 
    <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button> 
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>   
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>  
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>  
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="4" aria-label="Slide 5"></button>  
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="5" aria-label="Slide 6"></button>  
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="6" aria-label="Slide 7"></button>    
    </div> 
    <div className="carousel-inner"> 
     
     <div className="carousel-item active" data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld2.jpg" className="d-block w-100" alt="The Air Force School"/>
    
     </div>    
     <div className="carousel-item " data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld1.jpg" className="d-block w-100" alt="The Air Force School"/>
     <div className="slider-info">
     <h4>Education <span>is the most powerful weapon </span> </h4>
    
     </div>
     </div>  
     <div className="carousel-item" data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld4.jpg" className="d-block w-100" alt="The Air Force School"/>
     <div className="slider-info">
     <h4> Annual Prize  <span>  Distribution Ceremony  </span> </h4>
  </div>
     </div>
     <div className="carousel-item" data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld5.jpg" className="d-block w-100" alt="The Air Force School"/>
     <div className="slider-info">
     <h4> Annual Prize  <span>  Distribution Ceremony  </span> </h4>
  </div>
     </div>
     <div className="carousel-item" data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld6.jpg" className="d-block w-100" alt="The Air Force School"/>
     <div className="slider-info">
     <h4> Annual Prize  <span>  Distribution Ceremony  </span> </h4>
  </div>
     </div>
     <div className="carousel-item" data-bs-interval="3000">
     <img src="https://webapi.entab.info/api/image/TAFS/public/Images/sld7.jpg" className="d-block w-100" alt="The Air Force School"/>
     <div className="slider-info">
     <h4> Annual Prize  <span>  Distribution Ceremony  </span> </h4>
  </div>
     </div>
     </div> <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev"> <span className="carousel-control-prev-icon" aria-hidden="true"></span> <span className="visually-hidden">Previous</span> </button> <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next"> <span className="carousel-control-next-icon" aria-hidden="true"></span> <span className="visually-hidden">Next</span> </button> 
    </div>  
     <div className="thought">  
         <div>
         <div className="thoughtimg">  <img src="https://webapi.entab.info/api/image/TAFS/public/Images/though.png" className="img-fluid" alt="The Air Force School"/></div>
         <h4>Learn from Yesterday, Live for Today, hope for tomorrow <span> Albert Einstein </span> </h4> 
         </div>
     </div>

     <div className="mission">  
         <div className="missionimg">  <img src="https://webapi.entab.info/api/image/TAFS/public/Images/mision.png" className="img-fluid" alt="The Air Force School"/> 
            <div className="missiondesc"> <p>“to develop our students into responsible, harmonious and integrated individuals through ever evolving curricular and co-curricular activities”</p> </div>
        </div> 
     </div>
    </div>
    </div>
    </div>
    </>
  )
}

export default HomeSlider
